import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component
import { devConfig } from 'config/config'; // Import development configuration

/**
 * Class representing the finances customer agent list view.
 * @extends JetView
 */
export default class financescustomerAgentListView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Local ID for the layout
                    type: 'wide', // Layout type
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Local ID for the tab bar
                            height: 43, // Height of the tab bar
                            options: [
                                {
                                    id: 'agent.configuration.changePassword', // Tab ID
                                    value: _('Cambiar Contraseña'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'AgentConfigurationChangePasswordMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-AgentConfigurationChangePasswordMenu', // CSS class for styling
                                },
                                {
                                    id: 'agent.configuration.generateToken', // Tab ID
                                    value: _('Generar Token'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'AgentConfigurationGenerateTokenMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-AgentConfigurationGenerateTokenMenu', // CSS class for styling
                                },
                                {
                                    id: 'agent.configuration.securityChanges', // Tab ID
                                    value: _('Seguridad Cambios'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'AgentConfigurationSecurityChangesMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-AgentConfigurationSecurityChangesMenu', // CSS class for styling
                                },
                                {
                                    id: 'agent.configuration.qrgoogle', // Tab ID
                                    value: _('QR Google'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'AgentConfigurationQrgoogleMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-AgentConfigurationQrgoogleMenu', // CSS class for styling
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
